import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import Sidebar from '@/components/layout/Sidebar.vue';
import Navbar from '@/components/layout/Navbar.vue';
import AppMain from '@/components/layout/AppMain.vue';
import { useAppStore } from '@/stores/app';


import { defineComponent as __MACROS_defineComponent } from "vue";
const __default__ = __MACROS_defineComponent({
	name: 'DefaultLayout',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

;

/**
 * Accesso al store Pinia per lo stato UI
 */
const appStore = useAppStore();

/**
 * Reactive references dal store Pinia
 * isSidebarOpened è automaticamente reattivo
 */
const { isSidebarOpened } = storeToRefs(appStore);

/**
 * Classes CSS reattive per la sidebar
 * Automaticamente aggiornate quando lo stato cambia
 */
const sidebarClasses = computed(() => ({
	'sidebar-collapsed': !isSidebarOpened.value,
}));

return { __sfc: true,appStore, isSidebarOpened, sidebarClasses, Sidebar, Navbar, AppMain }
}

})